var map = {
	"./active.svg": 5577,
	"./bi_x.svg": 5429,
	"./deactivated.svg": 9539,
	"./discord-v2-svgrepo-com.svg": 4899,
	"./ended_status.svg": 1182,
	"./game_process_status.svg": 2524,
	"./hour.svg": 3841,
	"./login/auth-img.svg": 5357,
	"./login/auth0.svg": 4773,
	"./login/firebase.svg": 606,
	"./login/jwt.svg": 9984,
	"./min.svg": 4369,
	"./not_active.svg": 2855,
	"./not_started_status.svg": 5373,
	"./ru.svg": 9564,
	"./sec.svg": 6450,
	"./svg-icon/1.svg": 3179,
	"./svg-icon/2.svg": 5112,
	"./svg-icon/3.svg": 473,
	"./svg-icon/4.svg": 1062,
	"./svg-icon/5.svg": 39,
	"./svg-icon/6.svg": 5588,
	"./usa.svg": 6492,
	"./uz.svg": 9702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;